import React from 'react'
import {
  CustomReportChartSection,
  CustomReportInfoboxSection,
  CustomReportPieSection,
  CustomReportSectionsType
} from '../../../../../redux/context/customReports/typesSection'
import CustomChart from '../chart/CustomChart'
import CustomPieChart from '../chart/CustomPieChart'
import Editor from '../editor/Editor'
import InfoboxCard from '../infobox/InfoboxCard'
import { getTitleByLanguage } from '../customReportTable/utils'

interface SectionContentProps {
  section: CustomReportSectionsType
  printMode?: boolean
}

const SectionContent: React.FC<SectionContentProps> = ({ section, printMode }) => {
  switch (section.type) {
    case 'graph':
      return <CustomChart section={section as CustomReportChartSection} printMode={printMode} />
    case 'pie':
      return <CustomPieChart section={section as CustomReportPieSection} printMode={printMode} />
    case 'text':
      return <Editor editable={false} section={section} />
    case 'infobox':
      return (
        <InfoboxCard
          section={section as CustomReportInfoboxSection}
          title={getTitleByLanguage(section)}
          printMode={printMode}
        />
      )
    default:
      return null
  }
}

export default SectionContent
